<template>
    <b-container>
        <b-row>
            <b-col xs="12" class="border px-4 py-3 bg-light">
                <div class="linked-partner-badge-wrapper">
                    <b-badge
                        v-if="unlinkedMember"
                        pill
                        :variant="getBadgeVariant(member.active)"
                        class="ml-1">
                        Socio vinculado
                    </b-badge>
                </div>

                <div>
                    <b>Nombre y Apellidos:</b> 
                    <template v-if="unlinkedMember && unlinkedMember.name && unlinkedMember.surname">
                        {{ unlinkedMember.name }} {{ unlinkedMember.surname }}
                    </template>
                    <template v-else>
                        {{ member.name }} {{ member.surname }}
                    </template>
                </div>
                <div><b>Sede:</b> {{ member.headquarters.name }}</div>
                <div>
                    <b>Estado:</b>
                    <b-badge
                        pill
                        :variant="getBadgeVariant(member.active)"
                        class="ml-1">
                        {{ (!!member.active ? 'Activo' : 'Baja') }}
                    </b-badge>
                    <b-badge
                        pill
                        :variant="getBadgeVariant(member.located)"
                        class="ml-1">
                        {{ (!!member.active ? 'Localizado' : 'No Localizado') }}
                    </b-badge>
                </div>
                <div class="mt-2">
                    <router-link
                        :to="unlinkedMember ? { name: 'editPartner', params: { uuid: member.uuid }, query: {tab: 3}} : { name: 'editPartner', params: { uuid: member.uuid }}"
                        target="_blank">
                        Ver Ficha Completa
                    </router-link>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

    export default {
        name: "member-summary-small",
        components: {},
        props: {
            member: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        uuid: null
                    }
                }
            }
        },
        data: function () {
            return {
                notes: [],
                unlinkedMember: null
            }
        },
        mounted() {
            this.unlinkedMember = this.getUnlinkedMember();
        },
        methods: {
            getBadgeVariant(boolean) {
                return (boolean ? 'primary' : 'danger')
            },
            getUnlinkedMember() {
                if (this.member.hasOwnProperty('unlinkedMember') && this.member.unlinkedMember) {
                    return this.member.unlinkedMember;
                }

                return null;
            }
        },
        watch: {
            member: function (val) {
                this.unlinkedMember = this.getUnlinkedMember();
            }
        }
    }
</script>

<style scoped>
    .notes-container {
        height: 250px;
        overflow-y: scroll;
    }

    .linked-partner-badge-wrapper {
        position: absolute;
        top: 10px;
        right: 10px;
    }
</style>